import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function ReportsSummary({ children }) {
  useInjectSaga({ key: 'reportsSummary', saga });
  useInjectReducer({ key: 'reportsSummary', reducer });

  return React.Children.only(children);
}

ReportsSummary.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withReportsResume } from './withReportsResume';
export default compose(withConnect, memo)(ReportsSummary);
